// extracted by mini-css-extract-plugin
module.exports = {"btn":"DeletePost_btn__2Y_hB"};